import {
  Component,
  Input,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
/**
  Componente para mostrar un modal reutilizable con opciones configurables.
  Este componente permite mostrar un modal con propiedades personalizables,
  como tamaño, imagen de fondo, imagen de cierre, y estilos personalizados.
**/
@Component({
    selector: 'app-modal-refactor',
    templateUrl: './modal-refactor.component.html',
    styleUrls: ['./modal-refactor.component.scss'],
    standalone: false
})
export class modalRefactorComponent {
    /**
    Tamaño del modal. Por defecto es 'sd'.
  **/
    @Input() public size = 'sd';

    /**
      Imagen que se mostrará en el modal.
    **/
    @Input() public image = '';
  
    /**
      Color de fondo del modal. Por defecto es 'am-blue-premium'.
    **/
    @Input() public backGroundColor = 'am-blue-premium';
  
    /**
      Imagen que se usará como botón de cierre.
    **/
    @Input() public imageClose = '';
  
    /**
      Indica si se debe mostrar la imagen en el modal.
    **/
    @Input() public showImage: boolean = false;
  
    /**
      Indica si el modal está relacionado con un caso de "No Check-In".
    **/
    @Input() public isNoCkn: boolean = false;

    @Input() public isVerPass:boolean = false;
  
    /**
      Indica si se debe mostrar la imagen de cierre en el modal.
    **/
    @Input() public showImageClose: boolean = false;
  
    /**
      Clase CSS personalizada para el contenedor del modal.
    **/
    @Input() public classNameContainer = '';

  constructor(
    public modal: NgbActiveModal
    ) {}

   closeModalIcon() {
    this.modal.close();
   }
}
